import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { SeoProps } from "./types";

const Seo = ({ description, title, children }: SeoProps) => {
  const { site } = useStaticQuery(graphql`
    query siteData {
      site {
        siteMetadata {
          title
          description
          author
        }
      }
    }
  `);

  const seo = {
    title: title || site.siteMetadata.title,
    description: description || site.siteMetadata.description,
    // image: `${siteUrl}${image}`,
    // url: `${siteUrl}${pathname || ``}`,
    // twitterUsername,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {/* <meta name="image" content={seo.image} /> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      {/* <meta name="twitter:url" content={seo.url} /> */}
      <meta name="twitter:description" content={seo.description} />
      {/* <meta name="twitter:image" content={seo.image} /> */}
      {/* <meta name="twitter:creator" content={seo.twitterUsername} /> */}
      <link
        rel="icon"
        href="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='0.9em' font-size='90'>👤</text></svg>"
      />
      {children}
    </>
  );
};

export default Seo;
